import { z } from 'zod';

/**
 * Zod schema for the likely-duplicate-contract search attributes. All fields are optional;
 * combinations of buyerAssignedId and buyerCompanyId or sellerCompanyId need to be validated.
 */
export const zodContractDuplicateCheckParamsSchema = z
  .object({
    buyerAssignedId: z.string().trim().nullish(),
    buyerCompanyId: z.uuid().nullish(),
    sellerCompanyId: z.uuid().nullish(),
  })
  .refine((data) => {
    return (
      data.buyerAssignedId && (data.buyerCompanyId || data.sellerCompanyId)
    );
  });

const zodContractDuplicateCheckItemSchema = z.object({
  buyerAssignedId: z.string(),
  contractId: z.uuid(),
});

/**
 * Zod schema for the likely-duplicate-contract search response.
 */
export const zodContractDuplicateCheckResponseSchema = z.object({
  matches: z.array(zodContractDuplicateCheckItemSchema),
});
